import useText from "../hooks/useText";
import images from "../utilities/images";

const getItemDetails = (sku: string) => {
  const text = useText()?.overview;
  switch (sku.toLowerCase()) {
    case "ma1":
      return {
        sku: "MA1",
        price: "$74.95",
        buy: text.buy,
        text: text.singleAssessment,
        image: images.maCover,
      };
    case "maf":
      return {
        sku: "MAF",
        price: "$74.95",
        buy: text.buy,
        text: text.singleAssessment,
        image: images.maCover,
      };
    default: {
      throw new Error("The specified sku does not exist");
    }
  }
};

export default getItemDetails;
